import { Wish, WishlistInfo, Wishlist } from '../api/types';

/**
 * Extracts wish IDs from a wish array in their current order
 * @param wishes Array of wishes
 * @returns Array of wish IDs in the same order as the wishes
 */
export const buildWishIds = (wishes: Wish[]): string[] => {
  return wishes.map(wish => wish.id);
};

/**
 * Reorders wishes based on the provided wishIds array
 * Wishes in wishIds are placed first in that order, remaining wishes are appended at the end
 * @param wishes Array of wishes to reorder
 * @param wishIds Array of wish IDs defining the desired order
 * @returns Reordered array of wishes
 */
export const applyWishOrder = (wishes: Wish[], wishIds: string[]): Wish[] => {
  const orderedWishes: Wish[] = [];
  const wishMap = new Map(wishes.map(wish => [wish.id, wish]));
  
  // Add wishes in wishIds order
  wishIds.forEach(id => {
    const wish = wishMap.get(id);
    if (wish) {
      orderedWishes.push(wish);
      wishMap.delete(id);
    }
  });
  
  // Append remaining wishes not in wishIds
  orderedWishes.push(...Array.from(wishMap.values()));
  
  return orderedWishes;
};

/**
 * Builds an updated WishlistInfo object with new wish order
 * @param wishlist The current wishlist
 * @param newWishOrder The new order of wishes
 * @returns Updated WishlistInfo object with new wishIds
 */
export const buildUpdatedWishlistInfo = (wishlist: Wishlist, newWishOrder: Wish[]): WishlistInfo => {
  return {
    title: wishlist.title,
    cover: wishlist.cover,
    description: wishlist.description,
    access: wishlist.access,
    wishIds: buildWishIds(newWishOrder)
  };
};